import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../WalkOfShame";

export class WalkOfShameAdditionalFS extends PIXI.Container {
    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.ADDITIONAL_FS)?.addChild(this);
    }

    public showAdditionalFS(reelId: number, symId: number, extraFS: number, keypadCtr: number): void {
        const item: PIXI.Sprite = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("multipliers/+" + extraFS)[0]),
            tl: TimelineLite = new TimelineLite();

        item.anchor.set(0.5);
        item.scale.set(1.5);
        item.position.set(((144 * reelId) + (144 / 2)), ((148 * symId) + (148 / 2) + (reelId === 0 ? 162 : 89)));
        item.alpha = 0;

        if (this.children.length > 5) {
            this.removeChildren();
        }

        this.addChild(item);

        tl.to(item, {
            duration: 0.2,
            alpha: 1
        });
        tl.add(() => {
            WalkOfShame.keypadPlugin.setZeroBetSpinCounter(keypadCtr);
        });
        tl.to(item, {
            duration: 1,
            y: "-=296",
            alpha: 0
        });
        tl.add(() => {
            this.removeChild(item);
        });
    }
}